import React from 'react';
import { FAQSection } from '../components/sections/FAQSection';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
interface FAQPageProps {
  onBack: () => void;
}
export function FAQPage({
  onBack
}: FAQPageProps) {
  useDocumentMeta({
    title: 'Preguntas frecuentes sobre alineadores invisibles',
    description: 'Resolvemos las dudas más comunes de odontólogos y ortodoncistas sobre fabricación, costos, archivos requeridos y soporte de los alineadores invisibles Alinova en Colombia.',
    path: '/faq'
  });
  return <FAQSection onBack={onBack} data-id="element-899" data-mp="3ast0kmb94nm" />;
}